export type ImageContext = "flashcard" | "notes" | undefined;

export type SizeTier = "Small" | "Medium" | "Large";

const TIER_DISPLAY_MAX: Record<SizeTier, number> = {
  Small: 300,
  Medium: 450,
  Large: 750,
};

/** CSS max-width (px) for a filename size tier (2× sources display at half). */
export function getTierDisplayMaxWidth(tier: SizeTier): number {
  return TIER_DISPLAY_MAX[tier];
}

/** Legacy 1× assets: bucket by intrinsic width → 300 / 450 / 750. */
export function getLegacyDisplayMaxWidth(width: number): number {
  return width < 400 ? 300 : width < 600 ? 450 : 750;
}

export function getImageMaxWidth(
  width: number,
  context?: ImageContext,
  displayMaxWidth?: number
): string {
  if (context === "flashcard") {
    return width < 300
      ? "150px"
      : width < 600
      ? "300px"
      : width < 750
      ? "400px"
      : width < 1000
      ? "500px"
      : "750px";
  }

  if (displayMaxWidth != null) {
    return `${displayMaxWidth}px`;
  }

  return `${getLegacyDisplayMaxWidth(width)}px`;
}

export function nestedImageStyle(
  width: number,
  context?: ImageContext,
  displayMaxWidth?: number
): string {
  const maxWidth = getImageMaxWidth(width, context, displayMaxWidth);
  const widthStyle = context === "flashcard" ? "width:100%;" : "";
  const maxHeightStyle =
    context === "flashcard" ? "max-height:250px;" : "max-height:none;";
  const marginStyle =
    context === "flashcard" || context === "notes"
      ? "margin:0 auto;"
      : "margin:initial;";

  return `display:block;${widthStyle}max-width:min(${maxWidth},100%);height:auto;${maxHeightStyle}${marginStyle}`;
}
